const config = {
    // apiBaseUrl: "https://api-admin.neurolinkai.ai",
    apiBaseUrl: "https://api-admin.neurolinkai.dev",
    //apiBaseUrl: " http://localhost:3003",
    apiKey: "AKIAZI2LDEUZWO2YXBHO",
    secretAccessKey:"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"
  };
  
  export default config;
